module.exports = __webpack_public_path__ + "assets/img/英国 (1)@2x.a073d7f8.png";